<template>
  <div class="m3-container">
    <div class="m3-page">
      <!-- Hero Section -->
      <section class="page-content">
        <div class="left-title-box m3-main-text">
          <p class="text_7">M3</p>
          <span class="paragraph_1">Professional&nbsp;safety<br />tough&nbsp;guy&nbsp;temperament</span>
        </div>
        <div class="features-box">
          <img class="feature-img mobile-img" src="/static/images/product/m3-main.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m3-mianx2.png" alt="M3 Main" ref="lazyImg" />
        </div>
        <div class="scroll-mouse" v-show="showScrollMouse">
          <img src="static/images/mouse-w.png" alt="Scroll" />
          <p>Scroll Mouse</p>
        </div>
      </section>

      <!-- Functions Section -->
      <section class="page-content" style="display: block;">
        <div class="features-box">
          <img class="feature-img" src="/static/images/product/m3-function.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m3-functionx2.png" alt="M3 Functions" ref="lazyImg" />
        </div>
        <div class="title-box">
          <p class="text_10 bold-text">Perfect body</p>
          <p style="padding: 0 20px;font-size: 15px;font-family: MiSans-Regular;">A5 supports 12 functions, comprehensive detection of body risk, professional<br> version of body composition detection instrument</p>
        </div>
        <div class="function-box" style="text-align: center;">
          <div>Body composition analysis</div>
          <div>Athletic capacity Analysis</div>
          <div>Sp02</div>
          <div>Sports safety Analysis</div>
          <div>Body posture Analysis</div>
          <div>Detection Data Analysis</div>
          <div>Shoulder Joint Range of motion Evaluation Function</div>
          <div>Test Report</div>
        </div>
      </section>

      <!-- HD Screen Section -->
      <section class="page-content">
        <div class="left-title-box">
          <span class="text_19">32</span><span class="text_25">&nbsp; INCH</span><br />
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            src="https://lanhu-oss.lanhuapp.com/SketchPng51d007c2031a5b218f2a554568583021a00cfc62230930af9154ab1e3b0ceb80"
          />
          <br />
          <p class="text_21 bold-text" style="text-align: left;">HD SCREEN</p>
          <p>Immersive body testing <br>IPS HD Touch</p>
        </div>
        <div class="features-box">
          <img class="feature-img mobile-adjust" src="/static/images/product/m3-jishen.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m3-jishenx2.png" alt="M3 Body" ref="lazyImg" />
        </div>
      </section>

      <!-- Black Tempered Glass Section -->
      <section class="page-content">
        <div class="rightB-title-box">
          <p class="text_21 bold-text" style="padding: 0 20px;">Black <br>tempered glass</p>
          <p class="text_center">Highlight the beauty of industrial technology, minimalist high-end fashion</p>
        </div>
        <div class="features-box">
          <img class="feature-img mobile-adjust" src="/static/images/product/m3-dizuo.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m3-dizuox2.png" alt="M3 Base" ref="lazyImg" />
        </div>
      </section>

      <!-- Electrode Grip Section -->
      <section class="page-content">
        <div class="title-box txt-shoubing">
          <p class="text_21 bold-text" style="text-align: center;">Electrode&nbsp;grip&nbsp;3.0</p>
          <p class="text_center">Ergonomic&nbsp;design,&nbsp;designed&nbsp;for&nbsp;physical&nbsp;measurement,&nbsp;fully&nbsp;fit&nbsp;the&nbsp;curve&nbsp;of&nbsp;the&nbsp;palm</p>
        </div>
        <div class="features-box">
          <img class="feature-img mobile-adjust" src="static/images/product/m3-shoubing.png" alt="M3 Grip" />
        </div>
      </section>

      <!-- Industrial Sensor Section -->
      <section class="page-content" style="display: inline-block;">
        <div class="leftT-title-box txt-shoubing" style="bottom: -50vh;left: 8%;">
          <p class="text_21 bold-text" style="text-align: left !important;padding-left: 20px;">Industrial&nbsp;high&nbsp;precision<br>sensor</p>
          <p class="text_center" style="text-align: left;">Accurately&nbsp;measure&nbsp;the&nbsp;weight&nbsp;per&nbsp;gram&nbsp;of&nbsp;the&nbsp;human&nbsp;body&nbsp;and <br>
          the&nbsp;resistivity&nbsp;change&nbsp;per&nbsp;ohm&nbsp;to&nbsp;ensure&nbsp;the&nbsp;accuracy&nbsp;and&nbsp;stability<br>
          of&nbsp;the&nbsp;measurement&nbsp;results</p>
        </div>
        <div class="features-box">
          <img class="feature-img mobile-adjust" src="static/images/product/m3-xinpian.png" alt="M3 Sensor" />
        </div>
      </section>

      <!-- Administrator Platform Section -->
      <section class="page-content" style="display: inline-block;top: -80px;">
        <div class="title-box glht-text">
          <p class="text_21 bold-text">Administrator Platform</p>
        </div>
        <div class="features-box">
          <img class="feature-img mobile-adjust" src="static/images/product/m3-glht.png" alt="M3 Platform" />
        </div>
      </section>

      <!-- Medical Grade Section -->
      <div class="container">
        <div class="pj-box">
          <span class="text_21 bold-text">Medical grade</span>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <img src="static/images/product/a5-xy.png"/>
            <div class="img-desc">
              <p class="bold-text">Blood oxygen</p>
              <p>One minute resting heart rate and blood oxygen concentration were measured to assess the strength of cardiopulmonary function, providing accurate data support for daily training intensity planning.</p>
            </div>
          </div>
          <div class="col-lg-6">
            <img src="static/images/product/a5-xya.png"/>
            <div class="img-desc">
              <p class="bold-text">Blood pressure measurement</p>
              <p>Medical-grade blood pressure measurement to monitor exercise risk. Eliminate high blood pressure, women's menstrual exercise risk, make exercise more comfortable.</p>
            </div>
          </div>
        </div>
      </div>

    <!-- Technical Specifications Section -->
    <div class="container">
      <div class="tb-title">
        TECHNICAL SPECIFICATIONS:
      </div>
      
      <table class="tb technical-tb">
        <tr>
          <td class="tb-key">User ID Login/Phone Number Login</td>
          <td class="tb-key">On Screen Results</td>
        </tr>
        <tr>
          <td class="tb-key">Printable Results</td>
          <td class="tb-key">Handle Grips</td>
        </tr>
        <tr>
          <td class="tb-key">Weight</td>
          <td class="tb-key">BMI</td>
        </tr>
        <tr>
          <td class="tb-key">Body Fat Percentage</td>
          <td class="tb-key">Muscle Mass</td>
        </tr>
        <tr>
          <td class="tb-key">Visceral Fat Area</td>
          <td class="tb-key">Subcutaneous Fat Area</td>
        </tr>
        <tr>
          <td class="tb-key">Protein Content</td>
          <td class="tb-key">Total Body Water</td>
        </tr>
        <tr>
          <td class="tb-key">Skeletal Muscle</td>
          <td class="tb-key">BMR(kcal)</td>
        </tr>
        <tr>
          <td class="tb-key">Obesity Degree (%)</td>
          <td class="tb-key">Desirable Weight</td>
        </tr>
        <tr>
          <td class="tb-key">Weight Control</td>
          <td class="tb-key">Fat Control</td>
        </tr>
        <tr>
          <td class="tb-key">Muscle Control</td>
          <td class="tb-key">Segmental Muscle</td>
        </tr>
        <tr>
          <td class="tb-key">Segmental Body Fat</td>
          <td class="tb-key">Body Type Classification</td>
        </tr>
        <tr>
          <td class="tb-key">Fat-Free Body</td>
          <td class="tb-key">Bone Mass</td>
        </tr>
        <tr>
          <td class="tb-key">WHR</td>
          <td class="tb-key">Body Age</td>
        </tr>
        <tr>
          <td class="tb-key">SpO2 %</td>
          <td class="tb-key">Blood Pressure Test</td>
        </tr>
        <tr>
          <td class="tb-key">Exercise Intensity</td>
          <td class="tb-key">Body Posture Analysis</td>
        </tr>
        <tr>
          <td class="tb-key">Total Energy Expenditure (kcal)</td>
          <td class="tb-key">Calorie Consumption (kcal/hour)</td>
        </tr>
        <tr>
          <td class="tb-key">Expected Fat Burning (kg)</td>
          <td class="tb-key">Target Body Fat</td>
        </tr>
        <tr>
          <td class="tb-key">Exercise Program Advice</td>
          <td class="tb-key">Estimated Completion Period</td>
        </tr>
        <tr>
          <td class="tb-key">Body Composition History</td>
          <td class="tb-key">Pervious Data Comparison</td>
        </tr>
      </table>
      
      <h4 style="margin-top: 50px;margin-bottom: 20px;color: #FFFFFF;">M3 Body Composition Analyzer</h4>
      <table class="tb product-parameters">
        <tr>
          <td class="tb-col1" rowspan="7">Screen Host</td>
          <td class="tb-col2">Brand</td>
          <td class="tb-col3">Anovator</td>
        </tr>
        <tr>
          <td class="tb-col2">Product Name</td>
          <td class="tb-col3">Body Composition Analyzer</td>
        </tr>
        <tr>
          <td class="tb-col2">Model</td>
          <td class="tb-col3">M3</td>
        </tr>
        <tr>
          <td class="tb-col2">Color</td>
          <td class="tb-col3">Black</td>
        </tr>
        <tr>
          <td class="tb-col2">Operating System</td>
          <td class="tb-col3">Android 7.1</td>
        </tr>
        <tr>
          <td class="tb-col2">Camera</td>
          <td class="tb-col3">1080P</td>
        </tr>
        <tr>
          <td class="tb-col2">Material</td>
          <td class="tb-col3">Tempered Glass Led Screen + Aluminum Alloy</td>
        </tr>
        <tr>
          <td class="tb-col1" rowspan="3">Size & Weight</td>
          <td class="tb-col2">Product Size</td>
          <td class="tb-col3">
            Host: 1700mm*460mm
            <br />Base: 108mm*480mm*900mm
          </td>
        </tr>
        <tr>
          <td class="tb-col2">Package Size</td>
          <td class="tb-col3">
            Host: 1810mm*220mm*610mm
            <br />Base: 1010mm*577mm*180mm
          </td>
        </tr>
        <tr>
          <td class="tb-col2">Weight</td>
          <td class="tb-col3">50KG</td>
        </tr>
        <tr>
          <td class="tb-col1" rowspan="2">Display Screen</td>
          <td class="tb-col2">Screen Size</td>
          <td class="tb-col3">32 Inch</td>
        </tr>
        <tr>
          <td class="tb-col2">Screen Type</td>
          <td class="tb-col3">1080*1920 IPS HD Touch</td>
        </tr>
        <tr>
          <td class="tb-col1" rowspan="4">Technical Parameters</td>
          <td class="tb-col2">Measurement methods</td>
          <td class="tb-col3">8-point contact electrodes, multi-frequency bioelectrical impedance analysis technology</td>
        </tr>
        <tr>
          <td class="tb-col2">Frequency</td>
          <td class="tb-col3">20kHz；100kHz；250kHz</td>
        </tr>
        <tr>
          <td class="tb-col2">Electric Current</td>
          <td class="tb-col3">&lt;280uA</td>
        </tr>
        <tr>
          <td class="tb-col2">Power consumption</td>
          <td class="tb-col3">60W</td>
        </tr>
        <tr>
          <td class="tb-col1" rowspan="8">Function parameter</td>
          <td class="tb-col2">Report</td>
          <td class="tb-col3">Phone/Paper Print Report/Web</td>
        </tr>
        <tr>
          <td class="tb-col2">Voltage</td>
          <td class="tb-col3">
            Input: AC 220V，50/60Hz <br />
            Output：DC 12V,7A
          </td>
        </tr>
        <tr>
          <td class="tb-col2">Transmission Port</td>
          <td class="tb-col3">USB2.0/Bluetooth/Wired/Wireless</td>
        </tr>
        <tr>
          <td class="tb-col2">Height Range</td>
          <td class="tb-col3">80-200cm</td>
        </tr>
        <tr>
          <td class="tb-col2">Weight Range</td>
          <td class="tb-col3">0-200kg</td>
        </tr>
        <tr>
          <td class="tb-col2">Age Range</td>
          <td class="tb-col3">3-99 years old</td>
        </tr>
        <tr>
          <td class="tb-col2">Operating Environment</td>
          <td class="tb-col3">
            Internet Connection Required <br />
            Temperature: 10-40℃, Humidity: 30%-75% <br />
            Do not place the device by the window to avoid direct sunlight.<br />
            Do not shine direct light on the device screen.<br />
            Do not hit the device hard.
          </td>
        </tr>
        <tr>
          <td class="tb-col2">Save the environment</td>
          <td class="tb-col3">
            Temperature: -20~70℃, Humidity: ≤95%
          </td>
        </tr>
      </table>
    </div>

    <!-- 3D Product View Section -->
    <div class="product-3d-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <h2 class="section-title text-center" style="text-transform: uppercase;">M3 3D Product View</h2>
            <div class="iframe-container">
              <iframe 
                src="/static/web/m3/m3.html" 
                width="100%" 
                height="700px" 
                frameborder="0"
                class="product-iframe"
              ></iframe>
              <p class="iframe-desc">Drag to rotate • Double-click for fullscreen</p>
            </div>
          </div>
        </div>
      </div>
    </div>


    </div>
  </div>
</template>

<script>
import { lazyLoadingMixin } from '@/mixins/lazyLoading'

export default {
  name: 'M3',
  mixins: [lazyLoadingMixin],
  data() {
    return {
      showScrollMouse: true
    }
  },
  mounted() {
    document.title = 'M3 - Anovator';
    
    // 滚动鼠标显示控制
    window.addEventListener('scroll', this.handleScrollMouseVisibility);
    
    // 20秒后自动隐藏滚动鼠标
    setTimeout(() => {
      this.showScrollMouse = false;
    }, 20000);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScrollMouseVisibility);
  },
  methods: {
    handleScrollMouseVisibility() {
      this.showScrollMouse = window.scrollY <= 100;
    }
  }
}
</script>

<style scoped>
.m3-container {
  min-height: 100vh;
}

.m3-page {
  background-color: black;
  color: #FFFFFF;
}
.features-box{
  width: 100%;
  top: 0%;
}

/* 全局文字颜色设置 */
p, span, div, td, th {
  color: #FFFFFF;
}

.page-content {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  object-fit: cover;
}

.title-box {
  position: relative;
  text-align: center;
  z-index: 2;
  color: #FFFFFF;
  bottom: 90vh;
}
.function-box {
  position: absolute;
  display: inline-block;
  width: 80%;
  left: 10%;
  bottom: 20vh;
  margin: 0 auto;
  text-align: center;
}

.function-box div {
  display: inline-block;
  font-size: 15px;
  border-radius: 25px;
  padding: 12px 20px;
  background-color: rgba(26, 26, 26, 1);
  margin-right: 20px;
  margin-top: 10px;
  color: #FFFFFF;
  font-family: MiSans-Regular;
}

.text_10 {
    background-image: linear-gradient(360deg, rgba(192, 214, 255, 1) 0, rgba(238, 242, 255, 1) 100%);
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    text-transform: uppercase;
    font-family: MiSans-Bold;
    font-weight: 700;
    text-align: center;
    white-space: nowrap;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.text_24 {
  font-family: MiSans-Bold;
  font-size: 120px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 120px;
  letter-spacing: 0px;
  color: #FFFFFF;
}

.text_25 {
  font-family: MiSans-Bold;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #FFFFFF;
}

.bold-text {
  font-family: MiSans-Bold;
  color: #FFFFFF;
  font-weight: 600;
  font-size: 45px !important;
  line-height: 55px !important;
  text-transform: uppercase;
}

.text_19 {
  font-family: MiSans-Bold;
  font-size: 80px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 80px;
  letter-spacing: 0px;
  color: #FFFFFF;
}

.text_21 {
  font-family: MiSans-Bold;
  font-size: 36px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 36px;
  letter-spacing: 0px;
  color: #FFFFFF;
  text-transform: uppercase;
  text-align: left;
  padding-left: 10vw;
}

.left-title-box {
  position: absolute;
  left: 10%;
  top: 50%;
  transform: translateY(-50%);
  text-align: left;
  z-index: 2;
  color: #FFFFFF;
}

.rightB-title-box {
  position: absolute;
  right: 10%;
  bottom: 20%;
  text-align: right;
  z-index: 2;
  color: #FFFFFF;
}

.leftT-title-box {
  position: absolute;
  left: 10%;
  top: 20%;
  text-align: left;
  z-index: 2;
  color: #FFFFFF;
}

.txt-shoubing {
  bottom: 30vh;
  text-align: center;
  position: relative;
  margin: 0 auto;
  left: 34%;
}

.glht-text {
  color: #FFFFFF;
  bottom: -20vh;
}

.text_center {
  text-align: center;
  color: #FFFFFF;
}

.image_2 {
  width: 60px;
  height: 60px;
  object-fit: contain;
}

.features-box {
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: cover;
}

.feature-img {
  display: block;
  width: 100vw;
  margin: 0;
  padding: 0;
}

.scroll-mouse {
  position: absolute;
  bottom: 15%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}

.scroll-mouse img {
  width: 30px;
  height: 30px;
}

.scroll-mouse p {
  color: #FFFFFF;
  font-size: 12px;
  margin-top: 10px;
}

.pj-box {
  text-align: center;
  margin: 40px 0;
  color: #FFFFFF;
}

.img-desc {
  text-align: center;
  margin-top: 20px;
  color: #FFFFFF;
}

.img-desc p {
  color: #FFFFFF;
}

/* Hero Section Text Styles */
.text_7 {
  position: relative;
  width: 10.7vw;
  height: 8.82vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 6.66vw;
  font-family: MiSans-Bold;
  font-weight: 100;
  text-align: left;
  white-space: nowrap;
  line-height: 8.82vw;
  margin-bottom: 40%;
}

.paragraph_1 {
  position: relative;
  width: 50.28vw;
  height: 8.89vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 2.5vw;
  text-transform: uppercase;
  font-family: MiSans-Bold;
  font-weight: 700;
  text-align: left;
  line-height: 4.45vw;
}

/* Table Styles */
.tb-title {
  width: 100%;
  height: 300px;
  padding-top: 230px;
  font-size: 30px;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 35px;
}

.tb {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  margin-bottom: 50px;
  color: #FFFFFF;
}

.tb th, .tb td {
  border: 1px solid #3F3F3F;
  padding: 15px;
}

.tb tr {
  height: 40px;
}

.tb-key {
  width: 50%;
  background-image: url('../../../public/static/images/checkmark.png');
  background-repeat: no-repeat;
  background-size: 22px;
  background-position-y: 50%;
  background-position-x: 97%;
  padding-right: 30px;
}

.tb-col1 {
  width: 20%;
  font-weight: 600;
  text-align: center;
}

.tb-col2 {
  width: 30%;
  text-align: left;
}

.tb-col3 {
  width: 50%;
  text-align: left;
}

/* Container styles */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
}

.col-lg-6 {
  flex: 0 0 50%;
  max-width: 50%;
  padding: 0 15px;
  text-align: center;
}

.col-lg-6 img {
  max-width: 100%;
  height: auto;
  margin-bottom: 20px;
}

.product-3d-section {
  background-color: #f8f9fa;
  padding: 60px 0;
  margin-bottom: 40px;
}

.iframe-container {
  background: white;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  padding: 20px;
  margin: 0 auto;
  max-width: 1200px;
}

.product-iframe {
  border: none;
  border-radius: 10px;
  min-height: 300px;
}

.iframe-desc {
  text-align: center;
  margin-top: 15px;
  color: #666;
  font-size: 14px;
}

.section-title {
  margin-bottom: 30px;
  color: #333;
  font-weight: bold;
}

.text-center {
  text-align: center;
}

.justify-content-center {
  justify-content: center;
}

@media (max-width: 768px) {
  .text_10 {
    font-size: 32px;
    line-height: 32px;
  }
  
  .text_24 {
    font-size: 80px;
    line-height: 80px;
  }
  
  .text_25 {
    font-size: 18px;
    line-height: 18px;
  }
  
  .text_19 {
    font-size: 60px;
    line-height: 60px;
  }
  
  .text_21 {
    font-size: 28px;
    line-height: 28px;
  }
  
  .col-lg-6 {
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 30px;
  }
  
  .col-lg-10 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  
  .left-title-box, .rightB-title-box, .leftT-title-box {
    position: relative;
    left: auto;
    right: auto;
    top: auto;
    bottom: auto;
    transform: none;
    text-align: center;
    margin: 20px 0;
  }
  
  .page-content {
    flex-direction: column;
  }
  
  /* 移动端容器和表格优化 */
  .container {
    padding: 0 10px !important;
    margin: 0 auto !important;
  }
  
  .tb-title {
    font-size: 20px !important;
    margin-bottom: 20px !important;
    text-align: center !important;
  }
  
  .tb {
    font-size: 11px !important;
    margin: 10px 0 !important;
    width: 100% !important;
    table-layout: fixed !important;
  }
  
  .tb td {
    padding: 8px 5px !important;
    font-size: 11px !important;
    line-height: 1.3 !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    hyphens: auto !important;
  }
  
  .tb-key {
    background-size: 14px !important;
    background-position-x: 95% !important;
    padding-right: 18px !important;
    width: 50% !important;
  }
  
  /* 功能区域移动端优化 */
  .function-box {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 10px !important;
    margin: 20px 0 !important;
    padding: 0 15px !important;
  }
  
  .function-box div {
    font-size: 12px !important;
    padding: 10px 8px !important;
    text-align: center !important;
    background: rgba(255, 255, 255, 0.1) !important;
    border-radius: 5px !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
  }
  
  
  /* 3D产品展示区域移动端优化 */
  .product-3d-section {
    padding: 40px 0 !important;
    margin-top: 40px !important;
  }
  
  .iframe-container {
    padding: 15px !important;
    margin: 0 10px !important;
  }
  
  .product-iframe {
    height: 400px !important;
    min-height: 300px !important;
  }
  
  .section-title {
    font-size: 20px !important;
    margin-bottom: 20px !important;
  }
  
  /* 文本内容移动端优化 */
  .paragraph_1 {
    font-size: 16px !important;
    line-height: 1.4 !important;
  }
  
  .text_center {
    font-size: 14px !important;
    line-height: 1.4 !important;
    padding: 0 15px !important;
    overflow-wrap: anywhere;
  }
  
  .bold-text {
    font-size: 24px !important;
    line-height: 28px !important;
  }
  .mobile-adjust{
    height: auto;
  }
  .mobile-img{
    margin-top: 20vh;
  }
  .txt-shoubing{
    left: 0 !important;
    overflow-wrap: anywhere;
    bottom: -60vh !important;
  }
}

</style>